import { markRaw } from 'vue'
import PopupAbstract from './PopupAbstract'
import PopupAreas from './PopupAreas.vue'

export default class PopupAreasService extends PopupAbstract {
  public name = 'PopupAreasService'
  protected component = markRaw(PopupAreas)
}
